<template>
  <div class="main-body">
    <el-dialog title="编辑主体" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form">
        <el-form-item label="名称:" label-width="120px">
          <el-input v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="主体简称:" label-width="120px">
          <el-input v-model="form.short_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付方式:" label-width="120px">
          <el-input v-model="form.payment_method" disabled></el-input>
        </el-form-item>
        <el-form-item label="SDK LOGO:" label-width="120px">
          <el-upload
            class="avatar-uploader"
            :action="$store.state.host + 'admin/file_upload/image'"
            ref="upload"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="(response) => onUploadSuccess(response, 'logo')"
            :before-upload="(file) => setFile(file, 'logo')"
          >
            <div class="upload-card">
              <img v-if="logo" :src="logo" class="avatar" />
              <el-button type="primary">点击上传(1mb以内)</el-button>
            </div>
          </el-upload>
          <!-- <input
            type="file"
            style="display:none"
            accept="image/*"
            ref="floatLogo"
            @change="(response) => onUploadSuccess(response, 'float_logo')">
          <img v-if="form.float_logo" style="width:50px;" :src="form.float_logo" class="avatar" /> -->
        </el-form-item>
        <el-form-item label="悬浮窗LOGO:" label-width="120px">
          <el-upload
            class="avatar-uploader"
            :action="$store.state.host + 'admin/file_upload/image'"
            ref="upload"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="(response) => onUploadSuccess(response, 'float_logo')"
            :before-upload="(file) => setFile(file, 'float_logo')"
          >
            <div class="upload-card">
              <img v-if="float_logo" :src="float_logo" class="avatar" />
              <el-button type="primary">点击上传(1mb以内)</el-button>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="隐私政策" label-width="120px">
          <wEditor ref="editorPrivacy" :context="form.privacy" />
        </el-form-item>
        <el-form-item label="用户协议" label-width="120px">
          <wEditor ref="editorProtocol" :context="form.protocol" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <commonTable
      ref="commonTable"
      url="/admin/companies/list"
      reqMethod="GET"
      :column="column"
      limitKey="per_page"
    >
      <!-- <template #search>
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="hasPermission('员工新增')"
          @click="onAdd()"
          >新增</el-button>
      </template> -->
      <el-table-column label="主体logo" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.logo" style="width: 50px;" alt="主体logo">
        </template>
      </el-table-column>
      <el-table-column label="悬浮窗logo" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.float_logo" style="width: 50px;" alt="悬浮窗logo">
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            v-if="hasPermission('公司主体编辑')"
            @click="onEdit(scope.row)"
            >编辑</el-button>
        </template>
      </el-table-column>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import _ from 'lodash'

import commonTable from '@/component/commonTable.vue'
import wEditor from '@/component/wEditor'

export default {
  name: 'mainBody',
  components: {
    commonTable,
    wEditor
  },
  data () {
    return {
      dialogVisible: false,
      companiesList: [],
      form: {
        name: '',
        short_name: '',
        payment_method: '',
        logo: '',
        float_logo: '',
      },
      logo: '',
      float_logo: '',
      // 上传图片
      imageUrl: "",
    }
  },
  computed: {
    column () {
      return [
        {
          label: "名称",
          prop: "name"
        },
        {
          label: "主体简称",
          prop: "short_name"
        },
        {
          label: "支付方式",
          prop: "payment_method"
        },
      ]
    },
  },
  methods: {
    // 上传成功回调
    setFile (file, key) {
      this.form[key] = file
    },
    onUploadSuccess(response, key) {
      if (response.status) {
        this[key] = response.data.url;
        this.$message({
          type: "success",
          message: "上传成功",
        });
      }
    },
    resetForm () {
      this.form = {
        name: '',
        short_name: '',
        payment_method: '',
        logo: '',
        float_logo: '',
      }
      this.logo = ''
      this.float_logo = ''
    },
    onEdit (item) {
      this.resetForm()
      this.form = _.cloneDeep(item)
      this.logo = item.logo
      this.float_logo = item.float_logo
      this.dialogVisible = true
    },
    submitForm () {
      const form = _.cloneDeep(this.form)
      let data = new FormData()
      for (let key in form) {
        if (!['privacy', 'protocol'].includes(key)) {
          data.append(key, form[key])
        }
      }
      const privacy = this.$refs.editorPrivacy.html
      const protocol = this.$refs.editorProtocol.html
      if (privacy && privacy !== "<p><br></p>") {
        data.append('privacy', privacy)
      }
      if (protocol && protocol !== "<p><br></p>") {
        data.append('protocol', protocol)
      }
      fetch({
        url: '/admin/companies/edit',
        method: "POST",
        data
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "编辑成功",
          })
          this.$refs['form'].resetFields()
          this.$refs["commonTable"].reload()
          this.dialogVisible = false
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          })
        }
      })
    },
    getCompaniesList () {
      fetch({
        url: "/admin/companies/select",
        method: "GET",
      }).then((res) => {
        this.companiesList = res.data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      })
    },
  },
  mounted () {
    this.getCompaniesList()
  },
}
</script>

<style lang="less" scoped>
  .upload-card {
    display: flex;
    align-items: center;
    img {
      width:50px;
      margin-right: 10px;
    }
  }
</style>
